import React from "react";
import { SideMenu } from "./../../components";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import HomeHeaderImage from "./../../../assets/images/homeClassesHeaderImage.png";
import MostPopularCourses from "./../../../assets/images/profileImage.jpg";
import { MdOutlineLocationOn, MdVerifiedUser } from "react-icons/md";
import AboutUsImage from "./../../../assets/images/AboutUsImage.png";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
let Home = () => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="home-container" id="homeSection">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <div>
                <h1 className="home-header-heading">
                  Move beyond the limitation of gmits classes
                </h1>
                <p className="home-header-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse ultricies finibus ligula. In at convallis magna.
                </p>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <div>
                <img src={HomeHeaderImage} className="home-header-image" />
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
      <div className="card-data-main" id="coursesSection">
        <div className="card-header-main">
          <h1 className="card-header-heading">Most Popular Courses</h1>
          <Button
            className="view-all-button"
            variant="text"
            onClick={() => {
              navigate("/most-popular-courses", {
                state: { type: "authorized" },
              });
            }}
          >
            View all
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="card-main">
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">Lorem ipsum dolor sit a...</p>
                <div className="card-location-main">
                  <MdOutlineLocationOn color="#663399" />

                  <p className="card-location">burnside</p>
                </div>
                <div className="card-bottom-main">
                  <Button className="card-price-button" variant="text">
                    $20.00
                  </Button>
                  <Button
                    className="card-right-view-details-button"
                    variant="text"
                    onClick={() => {
                      navigate("/most-popular-courses/details", {
                        state: { type: "authorized" },
                      });
                    }}
                  >
                    View detail
                  </Button>
                </div>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="card-main">
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">Lorem ipsum dolor sit a...</p>
                <div className="card-location-main">
                  <MdOutlineLocationOn color="#663399" />

                  <p className="card-location">burnside</p>
                </div>
                <div className="card-bottom-main">
                  <Button className="card-price-button" variant="text">
                    $20.00
                  </Button>
                  <Button
                    className="card-right-view-details-button"
                    variant="text"
                    onClick={() => {
                      navigate("/most-popular-courses/details", {
                        state: { type: "authorized" },
                      });
                    }}
                  >
                    View detail
                  </Button>
                </div>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="card-main">
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">Lorem ipsum dolor sit a...</p>
                <div className="card-location-main">
                  <MdOutlineLocationOn color="#663399" />

                  <p className="card-location">burnside</p>
                </div>
                <div className="card-bottom-main">
                  <Button className="card-price-button" variant="text">
                    $20.00
                  </Button>
                  <Button
                    className="card-right-view-details-button"
                    variant="text"
                    onClick={() => {
                      navigate("/most-popular-courses/details", {
                        state: { type: "authorized" },
                      });
                    }}
                  >
                    View detail
                  </Button>
                </div>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="card-main">
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">Lorem ipsum dolor sit a...</p>
                <div className="card-location-main">
                  <MdOutlineLocationOn color="#663399" />

                  <p className="card-location">burnside</p>
                </div>
                <div className="card-bottom-main">
                  <Button className="card-price-button" variant="text">
                    $20.00
                  </Button>
                  <Button
                    className="card-right-view-details-button"
                    variant="text"
                    onClick={() => {
                      navigate("/most-popular-courses/details", {
                        state: { type: "authorized" },
                      });
                    }}
                  >
                    View detail
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
        <div className="card-header-main" id="tutorsSection">
          <h1 className="card-header-heading">Most Popular tutors</h1>
          <Button
            className="view-all-button"
            variant="text"
            onClick={() => {
              navigate("/most-popular-tutors", {
                state: { type: "authorized" },
              });
            }}
          >
            View all
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="tutors-card-main">
                <img src={MostPopularCourses} className="tutors-card-image" />
                <h1 className="tutors-card-heading">Melina Bauer</h1>
                <p className="tutors-card-email">MiaEder@gmail.com</p>
                <Button
                  className="view-details-button"
                  variant="text"
                  onClick={() => {
                    navigate("/most-popular-tutors/details", {
                      state: { type: "authorized" },
                    });
                  }}
                >
                  view details
                </Button>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="tutors-card-main">
                <img src={MostPopularCourses} className="tutors-card-image" />
                <h1 className="tutors-card-heading">Melina Bauer</h1>
                <p className="tutors-card-email">MiaEder@gmail.com</p>
                <Button
                  className="view-details-button"
                  variant="text"
                  onClick={() => {
                    navigate("/most-popular-tutors/details", {
                      state: { type: "authorized" },
                    });
                  }}
                >
                  view details
                </Button>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="tutors-card-main">
                <img src={MostPopularCourses} className="tutors-card-image" />
                <h1 className="tutors-card-heading">Melina Bauer</h1>
                <p className="tutors-card-email">MiaEder@gmail.com</p>
                <Button
                  className="view-details-button"
                  variant="text"
                  onClick={() => {
                    navigate("/most-popular-tutors/details", {
                      state: { type: "authorized" },
                    });
                  }}
                >
                  view details
                </Button>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="tutors-card-main">
                <img src={MostPopularCourses} className="tutors-card-image" />
                <h1 className="tutors-card-heading">Melina Bauer</h1>
                <p className="tutors-card-email">MiaEder@gmail.com</p>
                <Button
                  className="view-details-button"
                  variant="text"
                  onClick={() => {
                    navigate("/most-popular-tutors/details", {
                      state: { type: "authorized" },
                    });
                  }}
                >
                  view details
                </Button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
      <div className="home-about-section-main" id="aboutUsSection">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <div>
                <h1 className="home-header-heading home-about-us-heading">
                  Get know about us
                </h1>
                <p className="home-about-us-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse ultricies finibus ligula. In at convallis magna.
                </p>
                <p className="home-about-us-description">
                  Sed posuere nisl urna. Donec dignissim, nunc nec finibus
                  aliquam, odio quam molestie nisi, nec facilisis leo enim vel
                  ipsum.
                </p>
                <p className="home-about-us-description">
                  Ut varius, tortor a consectetur suscipit, magna mauris rutrum
                  diam, pulvinar euismod mauris augue quis erat
                </p>
              </div>
            </Grid>

            <Grid item xl={2} lg={2} md={12} sm={12} xs={12}></Grid>
            <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
              <div>
                <img src={AboutUsImage} className="home-about-us-image" />
              </div>
            </Grid>
          </Grid>
        </Box>
        <div className="home-about-us-message-main">
          <MdVerifiedUser color="#663399" size={30} />
          <h1 className="home-about-us-message-heading">100% safe & secure</h1>
          <p className="home-about-us-message-description">
            Lorem ipsum dolor sit amet, consectetur convallis magna.
          </p>
        </div>
      </div>
      <div className="card-data-main" id="testimonialSection">
        <h1 className="card-header-heading">Our Student says</h1>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="students-testimonials-card">
                <img
                  src={MostPopularCourses}
                  className="students-testimonials-card-profile"
                />
                <p className="students-testimonials-card-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque fringilla velit sed diam vestibulum, quis finibus
                  elit rutrum.
                </p>
                <h1 className="students-testimonials-card-username">
                  Samantha aryton
                </h1>
                <p className="students-testimonials-card-label">Student</p>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="students-testimonials-card">
                <img
                  src={MostPopularCourses}
                  className="students-testimonials-card-profile"
                />
                <p className="students-testimonials-card-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque fringilla velit sed diam vestibulum, quis finibus
                  elit rutrum.
                </p>
                <h1 className="students-testimonials-card-username">
                  Samantha aryton
                </h1>
                <p className="students-testimonials-card-label">Student</p>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="students-testimonials-card">
                <img
                  src={MostPopularCourses}
                  className="students-testimonials-card-profile"
                />
                <p className="students-testimonials-card-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque fringilla velit sed diam vestibulum, quis finibus
                  elit rutrum.
                </p>
                <h1 className="students-testimonials-card-username">
                  Samantha aryton
                </h1>
                <p className="students-testimonials-card-label">Student</p>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="students-testimonials-card">
                <img
                  src={MostPopularCourses}
                  className="students-testimonials-card-profile"
                />
                <p className="students-testimonials-card-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque fringilla velit sed diam vestibulum, quis finibus
                  elit rutrum.
                </p>
                <h1 className="students-testimonials-card-username">
                  Samantha aryton
                </h1>
                <p className="students-testimonials-card-label">Student</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
      <div className="card-data-main" id="eventsSection">
        <div className="card-header-main">
          <h1 className="card-header-heading">Upcomming Events</h1>
          <Button
            className="view-all-button"
            variant="text"
            onClick={() => {
              navigate("/upcomming-events", {
                state: { type: "authorized" },
              });
            }}
          >
            View all
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/upcomming-events/details", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">Lorem ipsum dolor sit a...</p>
                <div className="card-bottom-main">
                  <div className="card-location-main">
                    <MdOutlineLocationOn color="#663399" />

                    <p className="card-location">burnside</p>
                  </div>
                  <p className="card-upcomming-event-price">$2000</p>
                </div>
                <div className="card-bottom-main">
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                  <p className="card-upcomming-event-date">19 march 2022,</p>
                </div>
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/internationalTrip", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">International Trip</p>
                <div className="card-bottom-main">
                  <div className="card-location-main">
                    <MdOutlineLocationOn color="#663399" />

                    <p className="card-location">burnside</p>
                  </div>
                  <p className="card-upcomming-event-price">$2000</p>
                </div>
                <div className="card-bottom-main">
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                  <p className="card-upcomming-event-date">19 march 2022,</p>
                </div>
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/upcomming-events/details", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">Lorem ipsum dolor sit a...</p>
                <div className="card-bottom-main">
                  <div className="card-location-main">
                    <MdOutlineLocationOn color="#663399" />

                    <p className="card-location">burnside</p>
                  </div>
                  <p className="card-upcomming-event-price"></p>
                </div>
                <div className="card-bottom-main">
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                  <p className="card-upcomming-event-date">19 march 2022,</p>
                </div>
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/upcomming-events/details", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <p className="card-heading">Lorem ipsum dolor sit a...</p>
                <div className="card-bottom-main">
                  <div className="card-location-main">
                    <MdOutlineLocationOn color="#663399" />

                    <p className="card-location">burnside</p>
                  </div>
                  <p className="card-upcomming-event-price">$2000</p>
                </div>
                <div className="card-bottom-main">
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                  <p className="card-upcomming-event-date">19 march 2022,</p>
                </div>
              </Button>
            </Grid>
          </Grid>
        </Box>
      </div>

      <div className="card-data-main" id="letestUpdatesSection">
        <div className="card-header-main">
          <h1 className="card-header-heading">Our latest update</h1>
          <Button
            className="view-all-button"
            variant="text"
            onClick={() => {
              navigate("/our-latest-update", {
                stae: { type: "authorized" },
              });
            }}
          >
            View all
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/our-latest-update/details", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <div className="card-latest-update-desctiption-main">
                  <p className="card-latest-update-desctiption">
                    Aliquam nulla nulla, eleifend sit amet bibendum sit amet,
                    vulputate eget nunc
                  </p>
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                </div>
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/our-latest-update/details", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <div className="card-latest-update-desctiption-main">
                  <p className="card-latest-update-desctiption">
                    Aliquam nulla nulla, eleifend sit amet bibendum sit amet,
                    vulputate eget nunc
                  </p>
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                </div>
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/our-latest-update/details", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <div className="card-latest-update-desctiption-main">
                  <p className="card-latest-update-desctiption">
                    Aliquam nulla nulla, eleifend sit amet bibendum sit amet,
                    vulputate eget nunc
                  </p>
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                </div>
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <Button
                className="card-button-main"
                onClick={() => {
                  navigate("/our-latest-update/details", {
                    state: { type: "authorized" },
                  });
                }}
              >
                <img src={MostPopularCourses} className="card-image" />
                <div className="card-latest-update-desctiption-main">
                  <p className="card-latest-update-desctiption">
                    Aliquam nulla nulla, eleifend sit amet bibendum sit amet,
                    vulputate eget nunc
                  </p>
                  <p className="card-upcomming-event-date">14 march 2022,</p>
                </div>
              </Button>
            </Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default Home;
